import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

const Faq = ({faqsData}) => {
    const [openIndex, setOpenIndex] = useState(null);
    const faqRef = useRef(null); 
    const handleOpen = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (faqRef.current && !faqRef.current.contains(event.target)) {
                setOpenIndex(null);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);


   
    
    return (
        <div className="relative flex flex-col items-center justify-center w-full py-16 bg-white rounded-t-3xl bottom-10 gap-y-2">
            <h6 className="text-[26px] text-center sm:text-[32px] md:text-[40px] font-bold">
                FREQEUNTLY ASKED QUESTIONS
            </h6>
            <div className="section-line"></div>
            <p className="text-[16px] md:text-[20px] w-[97%] sm:w-[90%] md:w-[65%] lg:w-[55%] xl:w-[47%] text-center text-[#555555]">
                Here, you will find frequently asked questions that people want
                to know about me and my services.
            </p>

                        
            <div className="flex flex-col gap-y-5 md:gap-y-0 md:flex-row items-center justify-center md:items-start md:justify-evenly xl:justify-center xl:gap-x-10 w-[100%] xl:w-[85%] mt-5" ref={faqRef}>
                {/* Left FAQs */}
                <div className="flex flex-col items-center justify-center w-[95%] md:w-[350px] lg:w-[490px] xl:w-[500px] gap-y-5">
                {faqsData.slice(0, 4).map((faq) => (<div
                        key={faq.id}
                        className={`${
                            openIndex === faq.id
                                ? "min-h-[120px] bg-[#212425] text-white"
                                : "max-h-[97px] text-[#3e3e3e] bg-[#FAFAFA]"
                        }     border flex flex-col w-full rounded-md transition-all duration-500  p-3  overflow-hidden`}
                    >
                        <div
                            onClick={() => handleOpen(faq.id)}

                            className="flex items-center justify-between font-semibold cursor-pointer"
                        >
                            <div className="text-16px lg:text-[18px] flex items-center gap-x-4 w-full">
                                <h6 className="text-[48px] lg:text-[57px] ">{faq.id}</h6>
                                <h6
                                    className={`${
                                        openIndex === faq.id ? "border-white" : "border-black"
                                    } border-l-[1px] px-[10px] py-[5px] max-w-[76%] `}
                                >
                                    {faq.question}
                                </h6>
                            </div>
                            <IoIosArrowDown
                                size={25}
                                className={`${
                                    openIndex === faq.id
                                        ? "text-white -rotate-180"
                                        : "text-black rotate-0"
                                } transition-all duration-700`}
                            />
                        </div>

                        {/* contain after click */}
                        <div className="flex flex-col mt-4 text-sm gap-y-5 lg:text-base">
                            <p>
                                {faq.answer}
                            </p>
                        </div>
                    </div>
                ))}
                </div>
                
                {/*Right FAQs*/}
                <div className="flex flex-col items-center justify-center w-[95%] md:w-[350px] lg:w-[490px] xl:w-[500px] gap-y-5" 
>
                {faqsData.slice(4, 8).map((faq) => (<div
                        key={faq.id}
                        
                        className={`${
                            openIndex === faq.id
                            ? "min-h-[120px] bg-[#212425] text-white"
                            : "max-h-[97px] text-[#3e3e3e] bg-[#FAFAFA]"
                        } border flex flex-col w-full rounded-md transition-all ease-in-out duration-500  p-3  overflow-hidden`}
                    >
                        <div
                            onClick={() => handleOpen(faq.id)}
                            className="flex items-center justify-between font-semibold cursor-pointer"
                        >
                            <div className="text-16px lg:text-[18px] flex items-center gap-x-4 w-full">
                                <h6 className="text-[48px] lg:text-[57px] ">{faq.id}</h6>
                                <h6
                                    className={`${
                                        openIndex === faq.id ? "border-white" : "border-black"
                                    } border-l-[1px] px-[10px] py-[5px] max-w-[76%]`}
                                >
                                    {faq.question}
                                </h6>
                            </div>
                            <IoIosArrowDown
                                size={25}
                                className={`${
                                    openIndex === faq.id
                                        ? "text-white -rotate-180"
                                        : "text-black rotate-0"
                                } transition-all duration-700`}
                            />
                        </div>

                        {/* contain after click */}
                        <div className="flex flex-col mt-4 text-sm gap-y-5 lg:text-base">
                            <p>
                                {faq.answer}
                            </p>
                        </div>
                    </div>
                     ))}
                </div>
            </div>
        </div>
    );
};

export default Faq;
